(function () {
  angular
    .module("akitabox.asset.detail")
    .controller("AssetDetailController", AssetDetailController);

  /* @ngInject */
  function AssetDetailController(
    // Angular
    $q,
    $scope,
    // Third-party
    $state,
    // AkitaBox
    models,
    // Resolve
    asset,
    building,
    organization,
    // Services
    AssetService,
    NoteService,
    PinValueService,
    ToastService,
    UserService,
    WorkOrderService,
    CreateMessageDialog
  ) {
    var self = this;

    self.decommissioned = asset.is_decommissioned;

    // Copy of the original asset, used to revert changes
    var originalAsset;

    // Attributes
    self.asset = asset;
    self.building = building;
    self.activeTab = 0;
    self.headerActions = getHeaderActions();

    // Details
    self.floorValue = null;
    self.roomValue = null;
    self.installationYear = null;
    self.editingDetails = false;
    self.isOpen = true;
    self.readonly = true;
    self.actionMenuOpen = false;

    // Activity
    self.lastActivityItem = {
      activityType: "created-entity",
      entity: "Asset",
      entity_action_html: "This <b>Asset</b> was created",
      time: self.asset.created_date,
    };
    self.activityParams = {
      asset: self.asset._id,
    };

    self.showTasks = organization.show_tasks;
    self.showInstallDate = organization.show_installation_date_field;

    // set activity tab index based on whether or not wo tab is being displayed
    self.activityTabIndex = self.showTasks ? 2 : 1;

    // Functions
    self.showActivityTab = showActivityTab;
    self.showDetailsTab = showDetailsTab;
    self.showWorkOrdersTab = showWorkOrdersTab;
    self.fetchWorkOrders = fetchWorkOrders;
    self.saveDetails = saveDetails;
    self.createNote = createNote;
    self.onCancel = onCancel;
    self.addWorkOrder = addWorkOrder;
    self.addRequest = addRequest;
    self.toggleActionMenu = toggleActionMenu;

    init();

    /**
     * Initialize controller
     */
    function init() {
      // Save copy of the asset
      originalAsset = angular.copy(asset);

      self.installationYear = self.asset.installation_date
        ? new Date(self.asset.installation_date).getFullYear()
        : null;

      // Set floor and room
      self.floorValue = PinValueService.getFloorPinValue(asset.values);
      self.roomValue = PinValueService.getRoomPinValue(asset.values);

      // Detemine if user is allowed to make changes
      var permissions = UserService.getPermissions();
      self.readonly = !permissions.asset.update;
      self.readonlyLevel = !permissions.asset.update_level;
      self.readonlyRoom = !permissions.asset.update_room;
      self.canAddAttachments = permissions.asset.add_attachment;
    }

    function refreshActivity() {
      $scope.$broadcast("activity:refresh");
    }

    function toggleActionMenu() {
      self.actionMenuOpen = !self.actionMenuOpen;
    }

    function showDetailsTab() {
      self.activeTab = 0;
      self.isOpen = true;
    }

    function showWorkOrdersTab() {
      self.activeTab = 1;
      self.isOpen = true;
    }

    function showActivityTab() {
      self.activeTab = self.activityTabIndex;
      self.isOpen = true;
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;
      params[models.ASSET.ROUTE_SINGULAR] = self.asset._id;

      $state.go("app.workOrders.create", params);
    }

    function addRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;
      params[models.ASSET.ROUTE_SINGULAR] = self.asset._id;

      $state.go("app.serviceRequests.create", params);
    }

    function fetchWorkOrders(skip, status) {
      var query = {
        asset: self.asset._id,
        status: status,
        skip: skip,
        limit: 5,
      };
      return WorkOrderService.getByBuildingId(self.asset.building, query);
    }

    function saveDetails() {
      var data = {
        name: self.asset.name,
      };

      if (self.installationYear || self.installationYear === 0) {
        if (self.installationYear < 1000 || self.installationYear > 9999) {
          return $q.reject("Invalid year");
        }
        var installationDate = new Date(self.installationYear, 0, 2); // 01/02/YYYY
        data.installation_date = installationDate.getTime();
      } else {
        data.installation_date = null;
      }

      AssetService.updateById(self.building._id, self.asset._id, data)
        .then(function () {
          originalAsset.name = angular.copy(self.asset.name);
        })
        .catch(ToastService.showError);
    }

    function createNote(noteText) {
      if (!noteText || !noteText.length) return;
      var data = {
        asset: asset._id,
        text: noteText,
      };

      return NoteService.create(building._id, data)
        .then(function () {
          // Make sure to refresh the activity to show the new note when they're done creating one
          refreshActivity();
        })
        .catch(ToastService.showError);
    }

    function onCancel(properties) {
      // Make sure they're using an array
      if (!angular.isArray(properties)) {
        return;
      }

      for (var i = 0; i < properties.length; i++) {
        var property = properties[i];

        if (
          Object.prototype.hasOwnProperty.call(self.asset, property) &&
          Object.prototype.hasOwnProperty.call(originalAsset, property)
        ) {
          // reset the value back to the original only if it exist on both
          self.asset[property] = originalAsset[property];
        }
      }

      self.installationYear = self.asset.installation_date
        ? new Date(self.asset.installation_date).getFullYear()
        : null;
    }

    function getHeaderActions() {
      var actions = [
        {
          label: "Add Message",
          icon: "message",
          action: () => {
            self.actionMenuOpen = false;
            showActivityTab();
          },
        },
      ];

      return actions;
    }
  }
})();
